import React from "react";
import { set } from "dot-prop-immutable";
import { toolFormAttr, toolCollapseAttr, getLocale } from '@utils/util';
import { SimpleForm as Form, Collapse, Switch, Select, Radio } from '@whalecloud/fdx';
import CommonItemSettings from '@whalecloud/page-builder-base-components/components/ElementSettings/CommonItemSettings';
import OptionSettings from '@whalecloud/page-builder-base-components/components/ElementSettings/CascaderOptionSettings';

const { Panel } = Collapse;
const { Option } = Select;

const valueKey = 'data.formItemSettings';

const CascaderSettings = (props: any) => {
  const messages = getLocale();

  const { updateElement, element } = props;
  const { data: { formItemSettings = {} } = {} } = element;

  const {
    changeOnSelect = false,
    expandTrigger = 'click',
    popupPlacement = 'bottomLeft',
    showSearch = false,
    optionFilterProp = 'label',
  } = formItemSettings;

  const initialValues = {
    changeOnSelect,
    expandTrigger,
    popupPlacement,
    showSearch,
    optionFilterProp
  };

  const onFormChange = (obj: Object) => {
    Object.keys(obj).forEach((key: string) => {
      const propName = `${valueKey}.${key}`;
      const newElement = set(element, propName, obj[key]);

      updateElement({
        element: newElement,
      });
    });
  };
  return (
    <Collapse {...toolCollapseAttr} defaultActiveKey={['1', '2']}>
      <Panel header={messages['PAGEBUIDER_SETTINGS']} key="1">
        <CommonItemSettings showAutoInitialize />
        <Form {...toolFormAttr} initialValues={initialValues} onValuesChange={onFormChange}>
          <Form.Item label={messages['PAGEBUIDER_SETTINGS_CHANGE_ON_SELECT']} name="changeOnSelect" valuePropName="checked">
            <Switch />
          </Form.Item>
          <Form.Item label={messages['PAGEBUIDER_SETTINGS_EXPAND_TRIGGER']} name="expandTrigger">
            <Radio.Group buttonStyle="solid" size="small">
              <Radio.Button value="click">{messages['PAGEBUIDER_SETTINGS_TRIGGER_CLICK']}</Radio.Button>
              <Radio.Button value="hover">{messages['PAGEBUIDER_SETTINGS_TRIGGER_HOVER']}</Radio.Button>
            </Radio.Group>
          </Form.Item>
          <Form.Item label={messages['PAGEBUIDER_SETTINGS_POPUP_PLACEMENT']} name="popupPlacement">
            <Select>
              <Option value="bottomLeft">{messages['PAGEBUIDER_SETTINGS_PLACEMENT_BOTTOMLEFT']}</Option>
              <Option value="bottomRight">{messages['PAGEBUIDER_SETTINGS_PLACEMENT_BOTTOMRIGHT']}</Option>
              <Option value="topLeft">{messages['PAGEBUIDER_SETTINGS_PLACEMENT_TOPLEFT']}</Option>
              <Option value="topRight">{messages['PAGEBUIDER_SETTINGS_PLACEMENT_TOPRIGHT']}</Option>
            </Select>
          </Form.Item>
          <Form.Item label={messages['PAGEBUIDER_SETTINGS_SHOW_SEARCH']} name="showSearch" valuePropName="checked">
            <Switch />
          </Form.Item>
          {
            showSearch && (
              <Form.Item label={messages['PAGEBUIDER_SETTINGS_FILTER_PROP']} name="optionFilterProp">
                <Radio.Group buttonStyle="solid" size="small">
                  <Radio.Button value="label">label</Radio.Button>
                  <Radio.Button value="value">value</Radio.Button>
                </Radio.Group>
              </Form.Item>
            )
          }
        </Form>
      </Panel>
      <Panel header={messages['PAGEBUIDER_SETTINGS_FORM-TABS_SELECT_OPTIONS']} key="2">
        <OptionSettings element={element} updateElement={updateElement} />
      </Panel>
    </Collapse>

  );
};

export default CascaderSettings;
